export const site = {
  name: "诱惑吃瓜",
  slogan: "精选头条 · 高能热帖 · 猛料爆评",
  description:
    "诱惑吃瓜聚合全网娱乐热点、剧集讨论、综艺名场面与网络热议话题，精选头条、高能热帖、猛料爆评一站式呈现。",
  email: "hi@youhuochigua.com",
  year: 2026,
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "全部瓜料", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export const SITE_ORIGIN = "https://youhuochigua.example.com";